<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入手机号"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="ICCID">
        <el-input
          v-model="queryParams.iccid"
          placeholder="请输入ICCID"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
        />
      </el-form-item>
      <el-form-item  prop="type">
        <el-select v-model="queryParams.type" 
        placeholder="请选择短信类型" 
        style="width: 240px" 
        clearable
        @change="search"
        >
          <el-option
            v-for="item in smsTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" width="185px"></el-table-column>
      <el-table-column prop="smsType" label="类型" align="center"></el-table-column>
      <el-table-column prop="text" label="短信内容" align="center"></el-table-column>
      <el-table-column prop="remark" label="失败原因" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{row}">
            <span v-if="row.status =='1'">成功</span>
            <span v-else>失败</span>
          </template>
      </el-table-column>
      <el-table-column prop="createTime" label="发送时间" align="center"></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { smsRecordIndex } from "@/api/api.js"; //短信
export default {
  name:'smsRecord',
  data() {
    return{
      queryParams:{
        phone:undefined,
        iccid:undefined,
        type:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      smsTypes:[
        {
          value: 1,
          label: "实名"
        },
        {
          value: 2,
          label: "提现"
        },
        {
          value: 3,
          label: "解绑手机号"
        },
        {
          value: 4,
          label: "充值订单"
        },
        {
          value: 5,
          label: "微信个人中心登录"
        },
        {
          value: 6,
          label: "解约周期扣款"
        },
        {
          value: 7,
          label: "签约扣款"
        },
        {
          value: 8,
          label: "流量用量停机信息推送"
        },
        {
          value: 9,
          label: "快递单号提醒"
        },
        {
          value: 10,
          label: "预警消息提醒"
        }
      ],
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model: {
        ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      smsRecordIndex(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
  },
  mounted() {
    this.initData();
  },
  created() {

  }
};
</script>


